export const totemBasicTypes = {
    // Solicitudes
    getSolicitudes: '[TOTEM_BASIC] getSolicitudes',
    deleteSolicitud: '[TOTEM_BASIC] deleteSolicitud',
    tomarSolicitud: '[TOTEM_BASIC] tomarSolicitud',
    liberarSolicitud: '[TOTEM_BASIC] liberarSolicitud',

    // Boxes
    getBoxes: '[TOTEM_BASIC] getBoxes',
    insertBox: '[TOTEM_BASIC] insertBox',
    updateBox: '[TOTEM_BASIC] updateBox',
    deleteBox: '[TOTEM_BASIC] deleteBox',

    // Boxes Tomados
    getBoxesTomados: '[TOTEM_BASIC] getBoxesTomados',
    tomarBox: '[TOTEM_BASIC] tomarBox',
    liberarBox: '[TOTEM_BASIC] liberarBox',

    // Opciones
    getOpciones: '[TOTEM_BASIC] getOpciones',
    insertOpcion: '[TOTEM_BASIC] insertOpcion',
    updateOpcion: '[TOTEM_BASIC] updateOpcion',
    deleteOpcion: '[TOTEM_BASIC] deleteOpcion',

    // SubOpciones
    getSubOpciones: '[TOTEM_BASIC] getSubOpciones',
    insertSubOpcion: '[TOTEM_BASIC] insertSubOpcion',
    updateSubOpcion: '[TOTEM_BASIC] updateSubOpcion',
    deleteSubOpcion: '[TOTEM_BASIC] deleteSubOpcion',

    // Opciones Por Box
    insertOpcionPorBox: '[TOTEM_BASIC] insertOpcionPorBox',
};
